import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import classes from "./styles.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { setSidebarOpen } from "../../../../store/nav/reducer";
import usePath from "../../../../hooks/usePath";

const SideItem = ({ items, to, type, setNavIsOpen, isOpen }) => {
  const currentTheme = useSelector((state) => state.setCurrentTheme);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { name, links, open, icon } = items;
  const sideBarIsAcData = useSelector(
    (state) => state.setIsSidebar.IsOpenActiveData
  );
  const subnavIsOpen = sideBarIsAcData.find((s) => s.name === name)?.open;

  const { defaultMenu } = usePath();
  const [clickedLink, setClickedLink] = useState(null);
  const [isHovering, setIsHovering] = useState(false);
  const [submenuPos, setSubmenuPos] = useState({ top: 0, left: 0 });
  const itemRef = useRef(null);

  const openSideNav = () => {
    if (to) {
      navigate(to);
    }
  };

  const handleSubMenuClick = (link) => {
    setClickedLink(link);
  };

  const renderHoverSubmenu = () => {
    if (!isHovering || !links) return null;

    return createPortal(
      <div
        className={classes.hover_submenu}
        style={{
          top: submenuPos.top,
          left: submenuPos.left,
          position: "absolute",
        }}
      >
        {links.map((link, index) => (
          <div key={index} className={classes.sub_menu}>
            {link.to?.startsWith("https://") ? (
              <a href={link.to} target="_blank" rel="noopener noreferrer">
                <p style={{ color: currentTheme.text2 }}>{link.title}</p>
              </a>
            ) : (
              <NavLink to={link.to}>
                <p style={{ color: currentTheme.text2 }}>{link.title}</p>
              </NavLink>
            )}
          </div>
        ))}
      </div>,
      document.body
    );
  };

  return (
    <div
      ref={itemRef}
      className={classes.sideBar}
      onMouseEnter={() => {
        setIsHovering(true);
        if (itemRef.current) {
          const rect = itemRef.current.getBoundingClientRect();
          const availableBottom = window.innerHeight - rect.bottom;
          const estimatedSubmenuHeight = links?.length * 40;
          let top = rect.top;
          if (availableBottom < estimatedSubmenuHeight) {
            top = Math.max(window.innerHeight - estimatedSubmenuHeight - 10, 10);
          }
          let left = rect.right;
          const submenuWidth = 200;
          if (left + submenuWidth > window.innerWidth) {
            left = rect.left - submenuWidth;
          }
          setSubmenuPos({ top, left });
        }
      }}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div
        className={`${classes.menu_Container} ${!isOpen ? classes.collapsed : ""
          }`}
      >
        <div
          className={classes.icon}
          style={{
            color: isHovering ? currentTheme.text6 : currentTheme.text4,
          }}
        >
          {icon}
        </div>
        {isOpen && (
          <p
            onClick={() => {
              openSideNav();
              setNavIsOpen({ name, open });
            }}
            className={classes.menu}
            style={{
              color: currentTheme.text2,
            }}
          >
            <span>{name}</span>
            {links && (
              <div
                className={`rotate-icon ${subnavIsOpen ? "rotate" : ""}`}
                style={{
                  color: isHovering ? currentTheme.text2 : currentTheme.text2,
                }}
              >
                <KeyboardArrowRightRoundedIcon
                  style={{
                    transform: subnavIsOpen ? "rotate(90deg)" : "rotate(0deg)",
                    transition: "transform 180ms ease",
                    transformOrigin: "center",
                    display: "block",
                  }}
                />
              </div>

            )}
          </p>
        )}
      </div>
      {isOpen ? (
        <div className={`sub-menu ${subnavIsOpen ? "show" : ""}`}>
          {subnavIsOpen &&
            links?.map((link, index) => {
              const { title, to } = link;
              return (
                <div className={classes.sub_menu} key={index}>
                  {to?.startsWith("https://") ? (
                    <a href={to} target="_blank" rel="noopener noreferrer">
                      <p style={{ color: currentTheme.text2 }}>{title}</p>
                    </a>
                  ) : (
                    <NavLink onClick={() => handleSubMenuClick(title)} to={to}>
                      {({ isActive }) => (
                        <p
                          style={{
                            color: currentTheme.text2,
                            backgroundColor:
                              isActive && clickedLink === title
                                ? currentTheme.bg5
                                : currentTheme.bg6,
                          }}
                        >
                          {title}
                        </p>
                      )}
                    </NavLink>
                  )}
                </div>
              );
            })}
        </div>
      ) : (
        renderHoverSubmenu()
      )}
    </div>
  );
};

export default SideItem;
